import { Card, CardBody, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { LuDot } from "react-icons/lu";
import SessionUtil from "../util/SessionUtil";

function CardOrder({ data, storeData }) {
  const { t } = useTranslation();
  const lang = SessionUtil.getLang();
  return (
    <Card className="border-0 rounded-24 card-custome mb-5 card-user">
      <CardBody className="px-0">
        <div className="flex-gap-2 border-bottom border-w-6 pb-3 px-3">
          <div className="flex-gap-2">
            <div className="dimension-40 border rounded-pill">
              {storeData?.StoreImage ? (
                <Image
                  alt="image"
                  src={storeData.StoreImage}
                  className="img-fluid rounded-pill object-fit-initial"
                />
              ) : (
                <div className="img-empty rounded-pill"></div>
              )}
            </div>
            <div>
              <p className="mb-0 fw-medium text-uppercase font-15">
                {lang === "en" || storeData?.StoreNameAr
                  ? storeData?.StoreNameEn
                  : storeData?.StoreNameAr}
              </p>
              <p className="subtitle mb-0 fw-medium font-14">
                {storeData.StoreLocation}
              </p>
            </div>
          </div>
        </div>
        {/* ==================================================== */}
        {data.map((item, index) => {
          // Convert to a Date object
          const date = new Date(item.ItemCreatedDate);

          // Extract and format the components
          const day = date.getDate();
          const months = [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ];
          const month = months[date.getMonth()]; // Get abbreviated month name
          let hours = date.getHours();
          const minutes = String(date.getMinutes()).padStart(2, "0");
          hours = hours % 12 || 12; // Convert to 12-hour format
          // Combine into the desired format
          const formattedDateTime = `${day} ${month}, ${hours}:${minutes}`;
          return (
            <div
              key={index}
              className={`py-3 px-3 ${
                data.length - 1 > index && "border-bottom "
              } `}
            >
              <Image
                alt="image"
                src={item.ItemImage}
                className="img-fluid rounded w-100 max-h-120"
              />
              <div className="flex-gap-2 justify-content-between flex-wrap fw-semibold mt-3 fs-6">
                <p className="mb-0">
                  {lang === "en" || item?.ItemNameAr
                    ? item?.ItemNameEn
                    : item?.ItemNameAr}
                </p>
                <p className="mb-0">{item.ItemPrice} $</p>
              </div>
              <p className="mb-1">
                {t("Orders")} #{storeData.OrderId}
              </p>
              <p className="mb-0 flex-gap-2 gap-1 subtitle">
                <span>
                  {formattedDateTime}
                </span>{" "}
                <LuDot size={15} />{" "}
                <span>
                  {item.ItemCount} {t("Items")}
                </span>
              </p>
            </div>
          );
        })}
      </CardBody>
    </Card>
  );
}

export default CardOrder;
